import React, { Component } from "react";
import { Translate, I18n } from "react-redux-i18n";
import Dropdown from "react-bootstrap/Dropdown";
import "../../../../styles/components/account/manageAccount/formListGuestUsers.scss";

export class FormListGuestUsers extends Component {
  continue = (e) => {
    e.preventDefault();
    this.props.nextStep();
  };

  handleDeleteGuestUser = (id) => {
    this.props.deleteGuestUser(id);
  };

  handleEditGuestUser = (id) => {
    this.props.getGuestUser(id);
  };

  render() {
    const { list } = this.props;

    return (
      <div
        id="access-management-list"
        className="main-component main-container access-management-list"
      >
        <div className="component-container">
          <div className="row">
            <div className="col-sm-12">
              <h6>
                <Translate value="accessManagement_title" />
              </h6>
              <span>
                <Translate value="accessManagement_description" />
              </span>
            </div>
          </div>
          <div className="table-container">
            <div className="table-header">
              <div className="row no-gutters">
                <div className="col-12 row no-gutters titles">
                  <div className="col-3 title">
                    <Translate value="editAccount_title_name" />
                  </div>
                  <div className="col-4 title">
                    <Translate value="editAccount_title_email" />
                  </div>
                  <div className="col-4 title">
                    <Translate value="accessManagement_permissions" />
                  </div>
                  <div className="col-1 title" />
                </div>
              </div>
            </div>
            <div className="table-body">
              {list.length > 0 ? (
                <div className="row no-gutters">
                  {list.map((item) => (
                    <div className="col-12 row no-gutters guest-user-info">
                      <div className="col-3 body bgWhite">{item.name}</div>
                      <div className="col-4 body bgWhite">{item.email}</div>
                      <div className="col-4 body bgWhite">
                        {item.accessPlatform.api &&
                        item.accessPlatform.webclient &&
                        item.accessPlatform.mobile
                          ? "All"
                          : !item.accessPlatform.api &&
                            item.accessPlatform.webclient &&
                            item.accessPlatform.mobile
                          ? "webclient, mobile"
                          : item.accessPlatform.api &&
                            !item.accessPlatform.webclient &&
                            item.accessPlatform.mobile
                          ? "api, mobile"
                          : item.accessPlatform.api &&
                            item.accessPlatform.webclient &&
                            !item.accessPlatform.mobile
                          ? "api, webclient"
                          : item.accessPlatform.api &&
                            !item.accessPlatform.webclient &&
                            !item.accessPlatform.mobile
                          ? "api"
                          : !item.accessPlatform.api &&
                            item.accessPlatform.webclient &&
                            !item.accessPlatform.mobile
                          ? "webclient"
                          : !item.accessPlatform.api &&
                            !item.accessPlatform.webclient &&
                            item.accessPlatform.mobile
                          ? "mobile"
                          : "-"}
                      </div>
                      <div className="col-1 body body-dropdown bgWhite">
                        <Dropdown>
                          <Dropdown.Toggle id="dropdown-guest-user">
                            ...
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item
                              onSelect={() =>
                                this.handleEditGuestUser(item._id)
                              }
                            >
                              <Translate value="myChargersEdit_title" />
                            </Dropdown.Item>
                            <Dropdown.Item
                              onSelect={() =>
                                this.handleDeleteGuestUser(item._id)
                              }
                            >
                              <Translate value="myEvs_tabMyEvs_remove" />
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="row no-gutters d-flex justify-content-center">
                  <p className="py-4">
                    <Translate value="accessManagement_noGuestUsers" />
                  </p>
                </div>
              )}
            </div>
          </div>
          <div className="guest-user-btn">
            <button type="button" onClick={this.continue}>
              <Translate value="drivers_addUser" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default FormListGuestUsers;
